import type { Car } from "@views/Upholstery/types"
import { isPdmStructureV2Enabled } from "../helpers/flags/isPdmStructureV2Enabled"
import { usePickerCars } from "./usePickerCars"
import { PDM_CATALOG_LOAD_ERROR } from "../helpers/vehicle/loadPdmVehicleCatalogIntoStore"

/**
 * Single entry point for Step 1 vehicle picker data.
 * When `NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE` is off, returns SSR Dato `cars` unchanged.
 *
 * PDM catalog loading is owned by `useGlobalVehicleCatalogLoader` in `Layout`;
 * this hook only reads the store via `usePickerCars`.
 */
export function useUpholsteryV2VehiclePicker(datoCars: Car[]) {
  const isV2Enabled = isPdmStructureV2Enabled()

  const {
    cars: pdmPickerCars,
    loading: pdmCatalogLoading,
    error: pdmCatalogError,
  } = usePickerCars(datoCars)

  if (!isV2Enabled) {
    return {
      isV2Enabled: false as const,
      vehiclePickerCars: datoCars,
      vehiclePickerLoading: false,
      catalogError: null as string | null,
    }
  }

  return {
    isV2Enabled: true as const,
    vehiclePickerCars: pdmPickerCars,
    vehiclePickerLoading: pdmCatalogLoading,
    catalogError: pdmCatalogError ? PDM_CATALOG_LOAD_ERROR : null,
  }
}
